<script>
/* eslint-disable semi */
import { Notification } from 'element-ui';

const debug = process.env.NODE_ENV === 'development';

/**
 * 通知を表示する
 * @param {*} config
 * @param {*} args
 * @param {*} type
 */
function notification (config, args, type = null) {
  const marged = Object.assign({}, config);

  if (typeof args === 'string') {
    marged.message = args;
  } else {
    Object.assign(marged, args);
  }

  if (type) {
    Notification[type](marged);
  } else {
    Notification(marged);
  }
}

/**
 * 同一通知が連続で発生しないよう制御
 */
const lastNotify = {
  cache: {},
  isDupulicate: function (type, args) {
    let cached = null;
    if (type in this.cache) {
      cached = this.cache[type];
    }

    this.cache[type] = {
      time: (new Date()).getTime(),
      args: args
    }

    if (cached !== null) {
      if (((new Date()).getTime() - cached.time) < 100) {
        if (args === cached.args) {
          return true;
        }
      }
    }
    return false;
  }
};

/**
 * Notificationをラップしたnotify関数を生成する
 * @param {*} config
 */
function createNotify (config = {}) {
  function notify (args) {
    notification(config, args);
  }
  ['success', 'error', 'warning', 'info'].forEach(type => {
    Object.defineProperty(notify, type, {
      value: function (args) {
        // 同一通知が連続で発生しないよう制御
        if (lastNotify.isDupulicate(type, args)) {
          return;
        }
        notification(config, args, type);
      }
    });
  });
  return notify;
}

const AppPlugin = {
  install (Vue, options) {
    /**
     * Promiseチェーン終端での例外処理
     */
    Vue.prototype.$_app_ignore = function (...args) {
      if (debug) {
        console.debug('ignore', ...args);
      }
    };

    /**
     * 確認画面表示
     */
    Vue.prototype.$_app_confirm = function (message) {
      return this.$confirm(message);
    };

    /**
     * 通知表示
     */
    Vue.prototype.$_app_notify = createNotify({
      dangerouslyUseHTMLString: true
    });

    /**
     * パーツ群をグローバルコンポーネントとして登録する
     *
     * NOTE
     * importで参照すると、デコレータの初期化が行われる前にパーツコンポーネント
     * の初期化が実行される為、正常に動作しませんので注意してください。
     * また、このプラグイン自体もデコレータ用プラグインのインストール処理が完了
     * してから実行される必要があります。
     */
    const AppParts = require('@/app/parts');
    Object.keys(AppParts).forEach(key => {
      Vue.component(key, AppParts[key]);
    });
    const AppBlocks = require('@/app/blocks');
    Object.keys(AppBlocks).forEach(key => {
      Vue.component(key, AppBlocks[key]);
    });
  }
};

export default AppPlugin;
</script>



// WEBPACK FOOTER //
// src/app/AppPlugin.vue